module.exports = __webpack_public_path__ + "a837e124dbcb1eb15aae4b59e980da7a.pdf";